export const environment = {
  production: false,
  apiUrl: "https://deventerprise.condor.solutions/api/",
};
